export const WBNBAddress = '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c';
export const WBNBBUSDAddress = '0x58F876857a02D6762E0101bb5C46A8c1ED44Dc16';
export const BUSDAddress = '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56';
export const zeroAddress = '0x0000000000000000000000000000000000000000';
export const deadAddress = '0x000000000000000000000000000000000000dEaD';


export const legitPairs = [BUSDAddress, WBNBAddress];